export const interests = [
  {
    title: "AI use, disclosure and detection in Human-AI collaborations",
    desc: "..."
  },
  {
    title: "Long-form creative writing with LLMs: Generation and Evaluation",
    desc: "..."
  },
  {
    title: "Reasoning to improve long-form generations",
    desc: "..."
  },
  // {
  //   title: "Improving factuality of generations",
  //   desc: "..."
  // },
  {
    title: "Robustness of large language models",
    desc: "..."
  }
];